import { Component } from '@angular/core';
import { ModelSwitchOverlayService } from '../../services/model-switch-overlay.service';

@Component({
  selector: 'app-model-switch-overlay',
  templateUrl: './model-switch-overlay.component.html',
  styleUrls: ['./model-switch-overlay.component.scss']
})
export class ModelSwitchOverlayComponent {
  state$ = this.overlay.state$;
  constructor(public overlay: ModelSwitchOverlayService) {}
}
